import api from './api';

export const getFabricGrades = async () => {
  const { data } = await api.get('/fabric-grades');
  return data;
};

export const createFabricGrade = async (name, measurementUnit) => {
  const payload = { name };
  if (measurementUnit) payload.measurement_unit = measurementUnit;
  const { data } = await api.post('/fabric-grades', payload);
  return data;
};

export const updateFabricGrade = async (id, params) => {
  const { data } = await api.put(`/fabric-grades/${id}`, params);
  return data;
};

export const deleteFabricGrade = async (id) => {
  const { data } = await api.delete(`/fabric-grades/${id}`);
  return data;
};

export const updateGradePrices = async (id, prices) => {
  const { data } = await api.put(`/fabric-grades/${id}/prices`, { prices });
  return data;
};
